import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {FaUserLock} from "react-icons/fa";
import PropTypes from "prop-types";

export const SVPUpgradeSubscriptionIcon = ({
    message,
    fontSize = "15px",
    placement = "top", // "top" | "right" | "bottom" | "left"
    rightMargin = "5px",
}) => {
    return <>
        <span style={{marginRight: rightMargin}}></span>
        <OverlayTrigger
            placement={placement}
            overlay={<Tooltip id="tooltip-right" style={{fontSize: "12px"}}>
                {message}
            </Tooltip>}
        >
            <span>
                <FaUserLock
                    style={{
                        cursor: "pointer",
                        fontSize,
                    }}
                    color="Orange"
                    size={"20"}
                />
            </span>
        </OverlayTrigger>
    </>;
};

SVPUpgradeSubscriptionIcon.propTypes = {
    message: PropTypes.string.isRequired,
    fontSize: PropTypes.string,
    placement: PropTypes.string,
    rightMargin: PropTypes.string,
};
